import { MapProps } from 'react-map-gl/mapbox'
import { FogSpecification } from 'mapbox-gl'

type MapPropsDefaultType = {
  fog: NonNullable<MapProps['fog']>
  initialViewState: NonNullable<MapProps['initialViewState']>
  maxZoom: NonNullable<MapProps['maxZoom']>
  minZoom: NonNullable<MapProps['minZoom']>
}

const fog: FogSpecification = {
  // 'color': 'rgba(32,32,129,0.1)',
  'color': 'rgba(255,255,255,0.8)',
  'high-color': '#202081',
  // 'high-color': 'rgba(32,32,129,0.5)',
  'horizon-blend': 0.05,
  'range': [-10, 20],
  'space-color': '#141516',
  'star-intensity': 0.4,
}

const minZoom = window.innerWidth > 500 ? 1.4 : 1
const maxZoom = 18

const initialViewState: MapProps['initialViewState'] = {
  // bounds: [
  //   { lng: 180, lat: 90 },
  //   { lng: -180, lat: -59.011923153966144 },
  // ],
  // latitude: 46.499307690696384,
  // longitude: 26.31536500064732,
  latitude: 25.299965382215035,
  longitude: 4.105911001164145,
  zoom: minZoom,
}

export const MapPropsDefault: MapPropsDefaultType = {
  fog,
  initialViewState,
  maxZoom,
  minZoom,
}
